import React, { createContext, useContext, useState, useEffect } from 'react'
import { Experiment } from '@amplitude/experiment-js-client'

const ExperimentContext = createContext()
const DEPLOYMENT_KEY = 'client-SSdNm4FiU6mcPLMKkmWf9weHJEvCLMKi'

const ExperimentProvider = ({ children }) => {
  const [ampTestosteronePriceVariant, setAmpTestosteronePriceVariant] = useState('testosterone_pricing_variation_0')
  const [ampBloodflowPriceVariant, setAmpBloodflowPriceVariant] = useState('bloodflow_pricing_q1_25_variation_0')
  const [ampWeightlossPriceVariant, setAmpWeightlossPriceVariant] = useState('weight_loss_pricing_q1_25_variation_0')

  useEffect(() => {
    window.analytics.ready(async () => {
      const experiments = Experiment.initialize(DEPLOYMENT_KEY)
      const user = {
        device_id: window.analytics.user().anonymousId()
      }
      const options = {
        flagKeys: [
          'bloodflow_pricing_q1_25', 
          'testosterone_pricing', 
          'weight_loss_pricing_q1_25'
        ]
      }
      await experiments.fetch(user, options)
      const tp = experiments.variant('testosterone_pricing').value
      if (tp) {
        setAmpTestosteronePriceVariant(tp)
        window._ampTestosteronePriceVariant = tp
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'Testosterone_Pricing_Experiment_Q1_25',
          segment: tp,
        })
      }

      const bfpq125 = experiments.variant('bloodflow_pricing_q1_25').value
      if (bfpq125) {
        setAmpBloodflowPriceVariant(bfpq125)
        window._ampBloodflowPriceVariant = bfpq125
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'BloodFlow_Pricing_Experiment_Q1_25',
          segment: bfpq125,
        })
      }

      const wlpq125 = experiments.variant('weight_loss_pricing_q1_25').value
      if (wlpq125) {
        setAmpWeightlossPriceVariant(wlpq125)
        window._ampWeightlossPriceVariant = wlpq125
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'WeightLoss_Pricing_Experiment_Q1_25',
          segment: wlpq125,
        })
      }
    })
  }, [])

  return (
    <ExperimentContext.Provider
      value={{
        ampTestosteronePriceVariant,
        ampBloodflowPriceVariant,
        ampWeightlossPriceVariant
      }}
    >
      {children}
    </ExperimentContext.Provider>
  )
}

const useExperimentData = () => {
  return useContext(ExperimentContext)
}

export { ExperimentProvider, useExperimentData }
